import classNames from 'classnames';

export const fillPercentColorStyle = () =>
  classNames(`bg-[#CFFEDC]`, 'h-full', 'absolute', 'z-[1]', 'rounded-[10px]');
